"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[93],{

/***/ 1460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ CTABanner; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useClickOutside-726e7c36.mjs
var useClickOutside_726e7c36 = __webpack_require__(8643);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-d6406817.mjs
var Image_d6406817 = __webpack_require__(5905);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-479ac100.mjs
var Link_479ac100 = __webpack_require__(965);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Button-c598cb52.mjs
var Button_c598cb52 = __webpack_require__(7977);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/CTABanner.js











const x = "ctaBanner", l = "ctaBanner__image", L = "ctaBanner__content", _ = "ctaBanner__button-container", f = "ctaBanner__credits";
const k = "ctaBanner--has-image", C = "ctaBanner--employer", I = "ctaBanner--button-only", N = "ctaBanner--white", T = "ctaBanner--light-blue", P = "ctaBanner--gray", S = "post-article-section";
const j = (B) => {
  const { headline: a, body: n, image: t, link: o, btnText: d, alignToArticleSection: g, backgroundColor: i } = B, h = t?.altText === "", p = (0,useClickOutside_726e7c36.u)();
  return /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      topPadding: Block_9b78bd10.B.Padding.LARGE,
      bottomPadding: Block_9b78bd10.B.Padding.LARGE,
      className: (0,app_a75c1d35.c)(
        x,
        p && C,
        !!t && k,
        !a && !n && I,
        !a && !n && i === "white" && N,
        !a && !n && i === "lightBlue" && T,
        !a && !n && i === "gray" && P,
        g && S
      ),
      "data-testid": "cta-banner-block"
    },
    t && (h ? /* @__PURE__ */ react.createElement(
      "img",
      {
        src: t.imageLoader?.() || t.src,
        width: t.width,
        height: t.height,
        alt: "",
        "aria-hidden": "true",
        className: l,
        "data-testid": "cta-banner-image"
      }
    ) : /* @__PURE__ */ react.createElement(
      Image_d6406817.I,
      {
        credits: t.credits,
        src: t.src,
        width: t.width,
        height: t.height,
        altText: t.altText,
        imageLoader: t.imageLoader,
        className: l,
        styling: Image_d6406817.a.PREVIEW_CARD,
        "data-testid": "cta-banner-image"
      }
    )),
    /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { flex: !0, className: L }, !!a && /* @__PURE__ */ react.createElement("h2", { className: (0,app_a75c1d35.c)(app_a75c1d35.t.headingSection) }, a), !!n && /* @__PURE__ */ react.createElement("p", { className: (0,app_a75c1d35.c)(app_a75c1d35.t.textsLeadText) }, n), /* @__PURE__ */ react.createElement("div", { className: _ }, /* @__PURE__ */ react.createElement(
      Link_479ac100.L,
      {
        className: Button_c598cb52.B.PrimaryFocusStyleInLink,
        href: o.href,
        target: o.isExternalLink ? "_blank" : void 0,
        disableLinkTextStyle: !0,
        itemProp: "url"
      },
      /* @__PURE__ */ react.createElement(
        Button_c598cb52.B.Primary,
        {
          text: d || o.title,
          asDiv: !0
        }
      )
    ))),
    t && /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { flex: !0, className: f }, /* @__PURE__ */ react.createElement("div", { className: (0,app_a75c1d35.c)(app_a75c1d35.t.buttonTextPrimary) }, t.credits))
  );
};

//# sourceMappingURL=CTABanner.js.map

// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
// EXTERNAL MODULE: ./src/contexts/EmployerSiteContext.tsx
var EmployerSiteContext = __webpack_require__(981);
// EXTERNAL MODULE: ./src/util/cms-background-color.ts
var cms_background_color = __webpack_require__(4770);
;// CONCATENATED MODULE: ./src/magnolia/components/CTABanner/CTABanner.tsx








var transformLink = function(ctaBannerType) {
    var resolvedLink = (0,magnolia/* resolveLinkSwitchableField */.cJ)(ctaBannerType.link, false);
    return {
        title: ctaBannerType.btnText,
        href: resolvedLink.linkHref,
        isExternalLink: resolvedLink.isExternalLink
    };
};
function CTABanner(param) {
    var ctaBannerType = param.ctaBannerType;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    var alignToArticleSection = ctaBannerType.field === "buttonOnly" && Boolean(ctaBannerType.alignToArticleSection);
    var buttonOnlyBackgroundColor = ctaBannerType.field === "buttonOnly" ? (0,cms_background_color/* resolveCmsBackgroundColor */.A)(ctaBannerType.backgroundColor, isEmployerSite) : undefined;
    var props = {
        link: transformLink(ctaBannerType),
        btnText: ctaBannerType.btnText,
        alignToArticleSection: alignToArticleSection,
        backgroundColor: buttonOnlyBackgroundColor
    };
    if (ctaBannerType.field === "default" || ctaBannerType.field === "imageBackground") {
        props.headline = ctaBannerType.headline;
        props.body = ctaBannerType.bodyText;
    }
    if (ctaBannerType.field === "imageBackground") {
        var imageData = imageDataHandler(ctaBannerType.image);
        props.image = (0,_object_spread/* default */.Z)({
            credits: ctaBannerType.imageCredit || ctaBannerType.image.metadata.rights,
            altText: ""
        }, imageData);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(j, (0,_object_spread/* default */.Z)({}, props));
}

;// CONCATENATED MODULE: ./src/magnolia/components/CTABanner/index.ts
/* istanbul ignore file */ 


/***/ })

}]);